// extracted by mini-css-extract-plugin
export var block = "block-module--block--2rpM-";
export var title = "block-module--title--3p7To";
export var blockNoTitle = "block-module--blockNoTitle--12w7l";